import React from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { StencilProvider } from '@amzn/stencil-react-components/context';
import defaultTheme from '@amzn/stencil-react-theme-default';
import { AppInitWrapper } from './AppInitWrapper';
import { AppAuthentication } from './AppAuthentication';
import { AuthPage } from './AuthPage';
import { GuestPage } from './GuestPage';

/**
 * Main App Component for HRx Investigation Consent Service
 * Uses React Router for separate URLs:
 * - / (root) - Authenticated employee access
 * - /guest - Public guest access
 */
const App: React.FC = () => {
    return (
        <StencilProvider
            theme={{
                ...defaultTheme,
                constants: {
                    ...defaultTheme.constants,
                    maxWidth: '100%',
                },
            }}
        >
            <div className="app">
                <Router>
                    <Switch>
                        {/* Authenticated Employee Route */}
                        <Route 
                            exact
                            path="/" 
                            render={() => (
                                <AppInitWrapper>
                                    <AppAuthentication>
                                        <AuthPage />
                                    </AppAuthentication>
                                </AppInitWrapper>
                            )} 
                        />
                        
                        {/* Guest Access Route */}
                        <Route 
                            path="/guest" 
                            component={GuestPage} 
                        />
                        
                        {/* Redirect any unknown routes to root */}
                        <Redirect to="/" />
                    </Switch>
                </Router>
            </div>
        </StencilProvider>
    );
};

export default App;
